import React from 'react'

import useMediaQuery from './../../../utils/useMediaQuery';
import './winnersBody.scss';

const winner = [
    {
        date: 'Lunes 18 de octubre',
        winners: [
            { name: 'Sandra vargas', email: 'san*********5@gmail.com' },
            { name: 'Eliana Rúa', email: 'eli*********5@gmail.com' },
        ]
    },
    {
        date: 'Lunes 24 de octubre',
        winners: [
            { name: 'Sandra vargas', email: 'san*********5@gmail.com' },
            { name: 'Eliana Rúa', email: 'eli*********5@gmail.com' },
        ]
    },
    {
        date: 'Lunes 31 de octubre',
        winners: [
            { name: 'Sandra vargas', email: 'san*********5@gmail.com' },
            { name: 'Eliana Rúa', email: 'eli*********5@gmail.com' },
        ]
    },
    {
        date: 'Lunes 7 de octubre',
        winners: [
            { name: 'Sandra vargas', email: 'san*********5@gmail.com' },
            { name: 'Eliana Rúa', email: 'eli*********5@gmail.com' },
        ]
    },
    {
        date: 'Lunes 14 de octubre',
        winners: [
            { name: 'Sandra vargas', email: 'san*********5@gmail.com' },
            { name: 'Eliana Rúa', email: 'eli*********5@gmail.com' },
        ]
    },
];

const winnerSimple = [
    { date: 'Lunes 13 de Diciembre', name: 'Elizabeth Genes Fonzales', email: 'eliza******lez@gmail.com' },
    { date: 'Lunes 13 de Diciembre', name: 'Jessica Chavez', email: 'jaz******994@gmail.com' },
    { date: 'Lunes 6 de Diciembre', name: 'Liz Paola Barreto Vera', email: 'pao******819@gmail.com' },
    { date: 'Lunes 6 de Diciembre', name: 'Fabiana Rotelas', email: 'rote******na9@gmail.com' },
    { date: 'Lunes 29 de Noviembre', name: 'Rosa Zarza', email: 'rza******714@gmail.com' },
    { date: 'Lunes 29 de Noviembre', name: 'Liza Medina', email: 'liz******f02@gmail.com' },
    { date: 'Lunes 22 de Noviembre', name: 'Karen Mena Garcete', email: 'rst******16k@gmail.com' },
    { date: 'Lunes 22 de Noviembre', name: 'Evelyn Noelia Ocampos', email: 'eve*******oe@gmail.com' },
    { date: 'Lunes 15 de Noviembre', name: 'Magdalena Villalba Riquelme', email: 'magd*******33@gmail.com' },
    { date: 'Lunes 15 de Noviembre', name: 'Mariela López', email: 'ml65*******64@gmail.com' },
    { date: 'Lunes 8 de Noviembre', name: 'Cyntia Marisa Céspedes', email: 'mcesp*******sa@gmail.com' },
    { date: 'Lunes 8 de Noviembre', name: 'Laura Vera', email: 'xime******27@gmail.com' },
];

function WinnerBody() {
    const isMobile = useMediaQuery();

    return (
        <div className="f-roulette-winner__body">
            <div className="f-roulette-winner__body__header">
                <div className="f-roulette-winner__body__column-date">
                    <h2>
                        <span>SORTEO{isMobile && 'S'}</span>
                    </h2>
                </div>
                {!isMobile && <div className="f-roulette-winner__body__column-winner"><h2><span>GANADORAS</span></h2></div>}
            </div>

            <div className="f-roulette-winner__body__rows">

                {/* <div className="not-winner">
                    <h2>Conocé pronto las primeras ganadoras</h2>
                </div> */}
                {/* Sólo es descomentarear el siguiente código para mostrar la tabla de las ganadoras */}
                {winnerSimple.map((win, i) =>
                    <div className="f-roulette-winner__body__row" key={i}>
                        <div className="f-roulette-winner__body__column-date">
                            <span>{win.date}</span>
                        </div>
                        <div className="f-roulette-winner__body__column-winner">
                            <div className="f-roulette-winner__body__column">
                                {win.name}
                            </div>
                            <div className="f-roulette-winner__body__column">
                                {win.email}
                            </div>
                        </div>
                    </div>
                )}
            </div>

        </div>
    )
}

export default WinnerBody
